import React, { useEffect } from 'react'
import { withRouter, Link } from 'react-router-dom'

import JSONFormatter from 'ui/json-formatter/JSONFormatter'

import { deepObjectPropNamesToSnakeCase } from 'utils/nameStyle.utils'
import { withStores } from 'utils/helpers.utils'

const HmacKeysDetails = (props) => {
  const {
    match: {
      params: { id },
    },
    hmacKeysStore,
  } = props
  const { item, fetchItem } = hmacKeysStore

  useEffect(() => {
    hmacKeysStore.fetchItem(id)
  }, [])

  return (
    <div className='row'>
      <div className='col-6'>
        <JSONFormatter LinkComponent={Link} item={deepObjectPropNamesToSnakeCase(item)} action={fetchItem} />
      </div>
      <div className='col-6' />
    </div>
  )
}

export default withRouter(withStores(['hmacKeysStore'], HmacKeysDetails))
